import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=6d4d30ec&scoped=true"
import script from "./ContentBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentBlock.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&id=6d4d30ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d30ec",
  null
  
)

export default component.exports